import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/masjids/[slug]/MadrasaProfileClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/masjids/[slug]/MasjidOsProClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/masjids/[slug]/MasjidProfileClient.tsx");
